import { ToolboxItem } from "@/components/map-tool-box";
import {
  AddIcon,
  AddMultiModeIcon,
  EditIcon,
  EditLocationIcon,
  EditModeIcon,
  EditMultiModeIcon,
  ViewIcon,
} from "components/icons";

/**
 * The icons to be displayed in the toolbox, depending on mode.
 */

export enum RestrictionModeType {
  View = "view",
  AddCurbZoneRestriction = "addCurbZoneRestriction",
  EditCurbZoneRestriction = "editCurbZoneRestriction",
  AddTrafficRestriction = "addTrafficRestriction",
  EditTrafficRestriction = "editTrafficRestriction",
  MultiCreateCurbZoneRestriction = "multiCreateCurbZoneRestriction",
  MultiEditRestriction = "multiEditRestriction",
  AddPermitLocation = "addPermitLocation",
  EditPermitLocation = "editPermitLocation",
}

export const curbZoneRestrictionMode: RestrictionModeType[] = [
  RestrictionModeType.View,
  RestrictionModeType.AddCurbZoneRestriction,
  RestrictionModeType.EditCurbZoneRestriction,
  RestrictionModeType.MultiCreateCurbZoneRestriction,
  RestrictionModeType.MultiEditRestriction,
];
export const trafficRestrictionMode: RestrictionModeType[] = [
  RestrictionModeType.AddTrafficRestriction,
  RestrictionModeType.EditTrafficRestriction,
];
export const multipleRestrictionMode = [
  RestrictionModeType.MultiCreateCurbZoneRestriction,
  RestrictionModeType.MultiEditRestriction,
];

export const toolboxIcons: ToolboxItem<RestrictionModeType>[] = [
  {
    name: "Restriction",
    groups: [
      {
        text: "Voir",
        mode: RestrictionModeType.View,
        icon: <ViewIcon className="h-5 w-5" />,
      },
      {
        text: "Ajouter Restriction",
        mode: RestrictionModeType.AddCurbZoneRestriction,
        icon: <EditIcon className="h-5 w-5" />,
      },
      {
        text: "Modifier Restriction",
        mode: RestrictionModeType.EditCurbZoneRestriction,
        icon: <EditLocationIcon className="h-5 w-5" />,
      },
      {
        text: "Créer multiple restrictions",
        mode: RestrictionModeType.MultiCreateCurbZoneRestriction,
        icon: <AddMultiModeIcon className="h-5 w-5" />,
      },
      {
        text: "Modifier multiple restrictions",
        mode: RestrictionModeType.MultiEditRestriction,
        icon: <EditMultiModeIcon className="h-5 w-5" />,
      },
    ],
  },
  {
    name: "Traffic",
    groups: [
      {
        text: "Ajouter Restriction de traffic",
        mode: RestrictionModeType.AddTrafficRestriction,
        icon: <AddIcon className="h-5 w-5" />,
      },
      {
        text: "Modifier Restriction de traffic",
        mode: RestrictionModeType.EditTrafficRestriction,
        icon: <EditModeIcon className="h-5 w-5" />,
      },
    ],
  },
  {
    name: "Permis",
    groups: [
      {
        text: "Ajouter addresse de permis",
        mode: RestrictionModeType.AddPermitLocation,
        icon: <AddIcon className="h-5 w-5" />,
      },
      {
        text: "Modifier adresse de permis",
        mode: RestrictionModeType.EditPermitLocation,
        icon: <EditModeIcon className="h-5 w-5" />,
      },
    ],
  },
];
